exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-management-home-container {\n  overflow: auto;\n  height: calc( 100vh - 135px); }\n\n.visibility-hidden {\n  display: none; }\n\n.height-auto {\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/training-management/training-management.component.scss
// module id = ../../../../../src/app/core/components/training-management/training-management/training-management.component.scss
// module chunks = main